module.exports = __webpack_public_path__ + "203ff26c6f5edd9fa10ab74aadf62a65.pdf";